<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>
      <v-layout>
        <v-flex xs12 md6>
          <v-select
            :items="projects"
            v-model="resource.project_id"
            item-text="name"
            item-value="id"
            clearable
            chips
            small-chips
            :error-messages="validationErrors.project_id"
            label="Selecione o projeto">
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            :items="loadNotificationTypes"
            v-model="loadNotificationType"
            item-text="description"
            item-value="id"
            clearable
            chips
            small-chips
            return-object
            :error-messages="validationErrors.load_notification_type_id"
            label="Selecione o tipo de notificação">
          </v-select>
        </v-flex>

        <v-flex xs12 md2 v-if="showTelephone">
          <v-text-field
            label="Telefone"
            v-model="resource.telephone"
            v-mask="'(##)#####-####'"
            :error-messages="validationErrors.telephone">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md3 v-if="showWhatsAppType">
          <v-select
            :items="whatsAppTypeList"
            v-model="whatsAppType"
            item-text="description"
            item-value="slug"
            clearable
            chips
            small-chips
            :error-messages="validationErrors.whatsAppType"
            label="Selecione o tipo do WhastApp">
          </v-select>
        </v-flex>

        <v-flex xs12 md3 v-if="showWhatsAppTelephone">
          <v-text-field key="group_telephone"
            label="Telefone"
            v-model="whatsAppTelephone"
            v-mask="'(##)#####-####'"
            :error-messages="validationErrors.whatsAppTelephone">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md3 v-if="showWhatsAppGroup">
          <v-text-field key="group_whatsapp"
            label="Nome do Grupo"
            v-model="whatsAppGroupName"
            :error-messages="validationErrors.whatsAppGroupName">
          </v-text-field>
        </v-flex>

      </v-layout>
      <v-layout row wrap>

        <v-flex xs12 md5>
          <v-text-field
            label="Descrição"
            v-model="resource.ds_load_conf"
            :error-messages="validationErrors.ds_load_conf">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md2>
          <v-select
            :items="periodicityList"
            v-model="resource.ds_charge_periodicity"
            item-text="description"
            item-value="slug"
            clearable
            chips
            small-chips
            :error-messages="validationErrors.ds_charge_periodicity"
            label="Selecione a periodicidade">
          </v-select>
        </v-flex>

        <v-flex xs12 md2>
          <v-text-field
            label="Por Período"
            type="number"
            min="1"
            v-model="resource.qt_charge_periodicity"
            :error-messages="validationErrors.qt_charge_periodicity">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md3>
          <v-select
            :items="sendFileTypes"
            v-model="resource.sendFile"
            item-text="description"
            item-value="slug"
            clearable
            chips
            small-chips
            :error-messages="validationErrors.sendFile"
            label="Envio de arquivo">
          </v-select>
        </v-flex>

        <v-flex xs12 md5>
          <v-switch
            v-model="isActive"
            :label="`Ativo: ${isActive ? 'SIM' : 'NÃO'}`"
          ></v-switch>
        </v-flex>
      </v-layout>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import LoadConfService from '@/features/load-conf/LoadConfService';
import ProjectService from '@/features/project/ProjectService';
import LoadNotificationTypeService from '@/features/load-notification-type/LoadNotificationTypeService';

export default {
  name: 'load-conf-form',
  mixins: [CrudMixin],
  watch: {
    loadNotificationType() {
      this.selectNotificationType();
    },
    whatsAppType() {
      this.selectWhatsAppType();
    },
  },
  data() {
    return {
      isActive: false,
      isEditing: false,
      showWhatsAppType: false,
      showWhatsAppGroup: false,
      showWhatsAppTelephone: false,
      showTelephone: false,
      projects: [],
      loadNotificationTypes: [],
      loadNotificationType: {},
      whatsAppType: null,
      whatsAppGroupName: null,
      whatsAppTelephone: null,
      sendFileTypes: [
        { description: 'PDF', slug: 'pdf' },
        { description: 'Nenhum', slug: 'nenhum' },
      ],
      periodicityList: [
        { description: 'Minuto', slug: 'minute' },
        { description: 'Hora', slug: 'hour' },
        { description: 'Diariamente', slug: 'daily' },
        { description: 'Semanalmente', slug: 'weekly' },
        { description: 'Mensalmente', slug: 'monthly' },
        { description: 'Anualmente', slug: 'yearly' },
      ],
      whatsAppTypeList: [
        { description: 'Telefone', slug: 'Telefone' },
        { description: 'Grupo', slug: 'Grupo' },
      ],
      projectService: new ProjectService(),
      loadNotificationTypeService: new LoadNotificationTypeService(),
    };
  },
  beforeMount() {
    this.fetchProjects();
    this.fetchLoadNotificationType();
  },
  methods: {
    initCrud() {
      this.serviceType = LoadConfService;
      this.routerName = 'load-conf';
      this.componentType = 'FORM';
    },
    beforeSave() {
      this.resource.fl_active = this.isActive ? '1' : '0';
      this.resource.load_notification_type_id = this.loadNotificationType.id;
      this.resource.whatsAppType = this.whatsAppType;
      this.resource.whatsAppContact = this.whatsAppGroupName || this.whatsAppTelephone;
    },
    afterLoadResource() {
      this.isEditing = true;
      this.isActive = (this.resource.fl_active === '1');
      this.resource.project_id = parseInt(this.resource.project_id, 10);
      this.loadNotificationType = this.resource.load_notification_conf.load_notification_type;
      this.resource.sendFile = this.resource.load_notification_conf.sendFile;
      this.whatsAppType = this.resource.load_notification_conf.whatsAppType;
      if (this.whatsAppType === 'Grupo') {
        this.whatsAppGroupName = this.resource.load_notification_conf.whatsAppContact;
      } else if (this.whatsAppType === 'Telefone') {
        this.whatsAppTelephone = this.resource.load_notification_conf.whatsAppContact;
      }
    },
    selectWhatsAppType() {
      if (!this.isEditing) {
        this.whatsAppGroupName = null;
        this.whatsAppTelephone = null;
      }
      this.showWhatsAppTelephone = (this.whatsAppType === 'Telefone');
      this.showWhatsAppGroup = (this.whatsAppType === 'Grupo');
    },
    selectNotificationType() {
      if (!this.isEditing) {
        this.cleanWhatsAppData();
        this.cleanTelephoneData();
      }
      if (this.loadNotificationType && this.loadNotificationType.slug === 'whatsapp') {
        this.showWhatsAppType = true;
      } else if (this.loadNotificationType
        && (this.loadNotificationType.slug === 'sms'
        || this.loadNotificationType.slug === 'celphone')) {
        this.showTelephone = true;
      }
    },
    cleanWhatsAppData() {
      this.showWhatsAppType = false;
      this.showWhatsAppGroup = false;
      this.showWhatsAppTelephone = false;
      this.whatsAppType = null;
      this.whatsAppGroupName = null;
      this.whatsAppTelephone = null;
    },
    cleanTelephoneData() {
      this.showTelephone = false;
      this.resource.telephone = null;
    },
    async fetchProjects() {
      this.projects = await this.projectService.query();
    },
    async fetchLoadNotificationType() {
      this.loadNotificationTypes = await this.loadNotificationTypeService.query();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/load-conf/LoadConfForm.vue